
"use client";

import { useRouter } from "next/navigation";

import { AlertCircle, ArrowLeft } from "lucide-react";



export default function NotFound() {

  const router = useRouter();

  return (

    <div className="min-h-screen bg-gray-50 flex items-center justify-center">

      <div className="text-center">

        <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mx-auto mb-4">

          <AlertCircle className="text-red-500" size={32} />

        </div>

        <h1 className="text-4xl font-bold text-gray-900 mb-2">404</h1>

        <p className="text-gray-500 mb-6">Bu sayfa bulunamadı.</p>

        <button

          onClick={() => router.back()}

          className="inline-flex items-center gap-2 px-5 py-2.5 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors mr-3"

        >

          <ArrowLeft size={16} /> Geri Dön

        </button>

        <button

          onClick={() => router.push("/dashboard")}

          className="inline-flex items-center gap-2 px-5 py-2.5 bg-gray-100 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-200 transition-colors"

        >

          Dashboard

        </button>

      </div>

    </div>

  );

}

